
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {actions, connect} from 'mirrorx';

import {
  ReflexElement
} from 'react-reflex';

import { Scrollbars } from 'react-custom-scrollbars';
import SidebarTOC from './sidebar-toc';
import SidebarFiles from './sidebar-files';
import SidebarExporter from './sidebar-exporter';

import { Tabs, TabLink, TabContent }  from 'react-tabs-redux';

import './sidebar.css';

import Pages from '../enums/pages';

class Sidebar
  extends Component {

  getSize () {

    const domElement = ReactDOM.findDOMNode(this)

    switch (this.props.orientation) {

      case 'horizontal':
        return domElement.offsetHeight

      case 'vertical':
        return domElement.offsetWidth

      default:
        return 0
    }
  }

  showTutorial() {
    actions.layout.setPage(Pages.TUTORIAL)
  }
  componentDidMount() {
    actions.layout.setSidebarState(this.props);
  }

  componentDidUpdate() {
    if (this.props.real_size !== this.getSize()) {
      actions.layout.updateSidebarSize(this.getSize());
    }
  }

  render () {

    return (
      <ReflexElement {...this.props}>
        <Scrollbars>
          <Tabs className='sidebar-tabs'>
            <div className="sidebar-tab-links">
              <TabLink to="nav"><i className='icon-list' /></TabLink>
              <TabLink to="file"><i className='icon-progress-empty' /></TabLink>
              <TabLink to="exp"><i className='icon-export' /></TabLink>
              <TabLink to="info"><i className='icon-info-with-circle'/></TabLink>
            </div>
            <div className="sidebar-tab-content">
              <TabContent for="nav">
                
                  <SidebarTOC />
                
              </TabContent>

              <TabContent for="file">
                  <SidebarFiles />  
              </TabContent>
              <TabContent for="exp">

                <SidebarExporter />

              </TabContent>
              <TabContent for="info" style={{textAlign: 'center'}}>
                <h1>RUNE</h1>
                <p>v0.3</p>
                <h3>Developed by <a href='http://amorphic.space'>Amorphous</a></h3>
                <p>Powered by <a href='https://codemirror.net/'>Codemirror</a></p>
                <p>Entypo icons by <a href='http://entypo.com/index.php'>Daniel Bruce</a></p>
                <button disabled={this.props.layout.currentPage === Pages.TUTORIAL} className='btn' onClick={this.showTutorial}>Controls</button>
              </TabContent>
            </div>
          </Tabs>
        </Scrollbars>
      </ReflexElement>
    )
  }
}

export default connect(state => {
  return {layout: state.layout}
})(Sidebar);


// WEBPACK FOOTER //
// ./src/components/sidebar.js